import { Component } from '@angular/core';
import { GoogleTagManagerService } from 'angular-google-tag-manager';

@Component({
  standalone: false,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  constructor(private gtmService: GoogleTagManagerService) {
    // Add first GTM container (GTM-5XXHJRH) - handled by the service
    gtmService.addGtmToDom();
    
    // Add second GTM container (GTM-TVR3P3LC) manually
    this.addSecondaryGTM();
  }
  title = 'ClearScape Analytics Experience Web Console';

  /**
   * Adds the secondary Google Tag Manager container (GTM-TVR3P3LC)
   * This is added in addition to the primary GTM container configured in app.module.ts
   */
  private addSecondaryGTM(): void {
    // Add GTM script to head
    const gtmScript = document.createElement('script');
    gtmScript.innerHTML = `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-TVR3P3LC');
    `;
    document.head.insertBefore(gtmScript, document.head.firstChild);

    // Add noscript iframe to body
    const noscript = document.createElement('noscript');
    const iframe = document.createElement('iframe');
    iframe.src = 'https://www.googletagmanager.com/ns.html?id=GTM-TVR3P3LC';
    iframe.height = '0';
    iframe.width = '0';
    iframe.style.display = 'none';
    iframe.style.visibility = 'hidden';
    noscript.appendChild(iframe);
    document.body.insertBefore(noscript, document.body.firstChild);
  }

}

